module.exports = __webpack_public_path__ + "img/button_phone.d6096c18.png";